export default "__VITE_ASSET__ec430e89__"